<template>
    <div id="addAgencyAgreement">
      <a-form :form="agencyAgreementForm" layout="vertical">
        <div class="greyDiv">
          <a-row>
            <a-col :span="11">
              <a-form-item class="required" :label="$t('agencyAgreement.modal.proprietor')">
                <a-select :placeholder="$t('agencyAgreement.modal.proprietorTip')"
                          v-decorator="['ownerId',{rules: [
                            {required: true,message: $t('agencyAgreement.modal.proprietorTip'),},
                          ],}]"
                          showSearch
                          :showArrow="false"
                          :filterOption="false"
                          :defaultActiveFirstOption="false"
                          :notFoundContent="null"
                          @select="ownerSelect"
                          @search="initAllCompanyList"
                >
                  <a-icon slot="suffixIcon" type="caret-down" />
                  <div slot="dropdownRender" slot-scope="menu">
                    <v-nodes :vnodes="menu" />
                    <a-divider style="margin: 0;" />
                    <div class="addBottomBtn" @click="openAddProprietorModal">
                      <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                      <div class="addBtnText">{{$t('proprietor.proprietorModal.title')}}</div>
                    </div>
                  </div>
                  <a-select-option v-for="a in allCompanyList" :key="a.key" :value="a.id">
                    <div style="display:flex;">
                      <div style="flex:1;" class="invisible-item">
                        {{a.companyName}}
                      </div>
                      <div>
                        {{a.companySortNameCn}}
                      </div>
                    </div>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="11" :offset="2">
              <a-form-item class="required" :label="$t('agencyAgreement.modal.building')">
                  <a-select :placeholder="$t('agencyAgreement.modal.buildingTip')" @dropdownVisibleChange="openSelectMansion" v-decorator="['mansionIds',{rules: [
                                {required: true,message: $t('agencyAgreement.modal.buildingTip'),},
                                    ],}]"  mode="multiple" :maxTagCount="1" :label="$t('proprietor.proprietorModal.project')" @change="mansionChange" :open="false">
                    <a-select-option v-for="(mansion,index) in mansionList":key="index" :value="mansion.id">{{mansion.name}}</a-select-option>
                  </a-select>
              </a-form-item>
              <div class="addProjectBtn" @click="openSelectMansion">
                <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
              </div>
            </a-col>
               <!-- <pt-select v-decorator="['mansionIds',{rules: [
                {required: true,message: $t('agencyAgreement.modal.buildingTip'),},
                  ],}]"  mode="multiple" :maxTagCount="1" :placeholder="$t('agencyAgreement.modal.buildingTip')">
                  <a-select-option v-for="(mansion,index) in mansionList":key="index" :value="mansion.id">{{mansion.name}}</a-select-option>
                </pt-select>-->
          </a-row>
          <a-row>
            <a-col :span="11">
              <a-form-item :label="$t('agencyAgreement.agentTerm')">
                <a-range-picker  v-decorator="['agencyDate']" style="width: 100%" @change="dateChange"></a-range-picker>
              </a-form-item>
            </a-col>
            <a-col :span="11" :offset="2">
              <a-form-item :label="$t('agencyAgreement.signDate')">
                <pt-date-picker v-decorator="['signDate']" style="width: 100%"></pt-date-picker>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-item :label="$t('agencyAgreement.modal.dueTime')">
                <pt-select :placeholder="$t('agencyAgreement.modal.dueTimeTip')"
                          v-decorator="['dueTime']"
                >
                  <a-select-option v-for="duetime in dueTimeList" :key="duetime.wordKey" :value="duetime.wordKey">{{duetime.wordValue}}{{$t('baseVO.day')}}</a-select-option>
                </pt-select>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <div class="titleRow">
          <div class="circle"></div>
          <div class="titleText">{{$t('agencyAgreement.confirmStandard')}}</div>
        </div>
        <div class="greyDiv">
          <a-row>
            <a-col :span="24">
              <a-form-item style="margin-bottom: 10px;">
                <a-checkbox-group v-decorator="['customerConfirmationCriteria']" :options="customerConfirmationList" @change="onChange" />
              </a-form-item>
            </a-col>
<!--            returnCommissionAgreementRemarks-->
          </a-row>

          <a-row>
            <a-col :span="24">
              <a-form-item style="margin-bottom: 0;">
                <a-checkbox v-decorator="['isCustomerConfirmationCriteria']" @change="onChangeRemarks" v-model="isCustomerConfirmationCriteria">{{$t('agencyAgreement.otherRemarks')}}</a-checkbox>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item>
                <pt-input :class="isCustomerConfirmationCriteria ?'':'disabledClass'" type="textarea" :autosize="{minRows:3,maxRows:3}" v-decorator="['customerConfirmationCriteriaRemarks',{rules: [
                  {min: 2, max: 512, message: $t('agencyAgreement.modal.textAreaLength'), trigger: 'blur'},
                ],}]" :placeholder="$t('agencyAgreement.modal.remarksTip')" :disabled="!isCustomerConfirmationCriteria">
                </pt-input>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <div class="titleRow">
          <div class="circle"></div>
          <div class="titleText">{{$t('agencyAgreement.commissionStandard')}}</div>
        </div>
        <div class="greyDiv">
          <a-row>
            <a-col :span="24">
              <a-form-item style="margin-bottom: 10px;">
                <a-checkbox-group v-decorator="['commissionStandard']" :options="commissionStandardList" @change="onChange" />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :span="24">
              <a-form-item style="margin-bottom: 0;">
                <a-checkbox v-decorator="['isCommissionStandard']" @change="onChangeRemarks" v-model="isCommissionStandard">{{$t('agencyAgreement.otherRemarks')}}</a-checkbox>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item>
                <pt-input :class="isCommissionStandard ?'':'disabledClass'" type="textarea" :autosize="{minRows:3,maxRows:3}"  v-decorator="['commissionStandardRemarks',{rules: [
                  {min: 2, max: 512, message: $t('agencyAgreement.modal.textAreaLength'), trigger: 'blur'},
                ],}]" :placeholder="$t('agencyAgreement.modal.remarksTip')" :disabled="!isCommissionStandard">
                </pt-input>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <div class="titleRow">
          <div class="circle"></div>
          <div class="titleText">{{$t('agencyAgreement.attention')}}</div>
        </div>
        <div class="greyDiv">
          <a-row>
            <a-col :span="24">
              <a-form-item style="margin-bottom: 10px;">
                <a-checkbox-group v-decorator="['mattersNeedingAttention']" @change="onChange" >
                  <a-row  v-for="(item,index) in mattersNeedingAttentionList" :key="index" :style="index == 0?'margin-bottom:20px':''">
                    <a-col>
                      <a-checkbox :value="item.value">{{item.label}}</a-checkbox>
                    </a-col>
                  </a-row>
                </a-checkbox-group>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item  prop="returnCommissionAgreementRemarks" :class="isMattersNeedingAttention?'required':''">
                <pt-input :class="mattersNeedingAttention.indexOf('return_commission_agreement') > -1 ?'':'disabledClass'" type="textarea" :autosize="{minRows:3,maxRows:3}" v-decorator="['returnCommissionAgreementRemarks',{rules: [
                  mattersNeedingAttention.indexOf('return_commission_agreement') > -1 ?{required:true,message:$t('agencyAgreement.modal.returnRemarksTip'), trigger: 'blur'}:{},
                  {min: 2, max: 512, message: $t('agencyAgreement.modal.textAreaLength'), trigger: 'blur'},
                ],}]" :placeholder="$t('agencyAgreement.modal.returnRemarksTip')" :disabled="mattersNeedingAttention.indexOf('return_commission_agreement') == -1">
                </pt-input>
              </a-form-item>

            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item style="margin-bottom: 0;">
                <a-checkbox  v-decorator="['isMattersNeedingAttention']" @change="onChangeRemarks" v-model="isMattersNeedingAttention">{{$t('agencyAgreement.otherRemarks')}}</a-checkbox>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item >
                <pt-input :class="isMattersNeedingAttention ?'':'disabledClass'" type="textarea" :autosize="{minRows:3,maxRows:3}" v-decorator="['mattersNeedingAttentionRemarks',{rules: [
                  {min: 2, max: 512, message: $t('agencyAgreement.modal.textAreaLength'), trigger: 'blur'},
                ],}]" :placeholder="$t('agencyAgreement.modal.remarksTip')" :disabled="!isMattersNeedingAttention">
                </pt-input>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <div class="fileRow">
          <div class="fileRowLeft">
            <div class="circle"></div>
            <div class="fileTitle">{{$t('agencyAgreement.modal.files')}}</div>
            <div class="fileTip">{{$t('agencyAgreement.modal.filesTip')}}<span class="startStyle">*</span></div>
          </div>
          <pt-oss-upload @onSuccess="onSuccess">
            <a-button size="small"><pt-icon type="icon-shangchuanfujian"></pt-icon>{{$t('agencyAgreement.modal.uploadFile')}}</a-button>
          </pt-oss-upload>
        </div>
        <div class="fileDiv">
          <div v-if="fileList.length > 0">
            <div v-for="(item,index) in fileList" :key="index" class="fileItem">
              <pt-icon type="icon-fujian2" class="fileIcon"></pt-icon>
              <div class="fileName">{{item.fileName}}</div>
              <div @click="delFile(index)">
                <pt-icon class="delIcon" type="icon-tubiao"></pt-icon>
              </div>
            </div>
          </div>
          <div v-else class="noFileClass">
            <pt-empty><span slot="description">{{$t('leaveRecords.tips.emptyFile')}}</span></pt-empty>
          </div>
        </div>
      </a-form>
      <pt-modal :title="proprietorModalTitle" :visible="proprietorModalVisible"
                @ok="saveProprietor" @cancel="cancelAddProprietorModal" :width="800">
        <div slot="content">
          <add-proprietor ref="addProprietorRef" v-model="proprietorModalTitle" @saveSuccess="saveProprietorSuccess"></add-proprietor>
        </div>
      </pt-modal>


      <pt-modal :title="$t('proprietor.selectMansionModal.title')" :visible="selectModel.visable" :loading="selectModel.loading"
                @ok="submitEvent" @cancel="cancelEvent" :width="800">
        <div slot="content">
          <select-mansion-industrial :mansionList="mansionList" :mansionType="mansionType" ref="selectMansion" @confirmSelect="confirmSelect"></select-mansion-industrial>
        </div>
      </pt-modal>
    </div>
</template>

<script>
  import PtModal from "../../../../components/modal/index";
  import SelectMansionIndustrial from '../../proprietor/module/selectMansionIndustrial';
  import linkmanChangeRecordsApi from '@/api/database/linkmanChangeRecords'
  import agencyAgreementApi from '@/api/database/agencyAgreement'
  import {getDatadictChildsByPath} from '@/api/sys/datadict';
  import moment from 'moment'
  import PtInput from "../../../../components/form/input";
  import AddProprietor from '../../proprietor/module/addProprietor'
  import ownerMansionApi from '@/api/database/ownerMansion'
  export default {
    name: 'addAgencyAgreement',
    props:{
      agencyAgreementId: null,
    },
    components:{
      AddProprietor,
      PtInput,
      PtModal,
      SelectMansionIndustrial,
      VNodes: {
        functional: true,
        render: (h, ctx) => ctx.props.vnodes,
      },
    },
    data(){
      return{
        proprietorModalTitle:'',
        proprietorModalVisible:false,
        agencyAgreementForm: this.$form.createForm(this,{}),
        fileList:[],
        plainOptions:['Apple', 'Pear', 'Orange'],
        confirmStandard:[],
        isCustomerConfirmationCriteria:false,
        isCommissionStandard:false,
        isMattersNeedingAttention:false,
        customerConfirmationList:[],//客户标准集合
        commissionStandardList:[],//结佣标准
        mattersNeedingAttentionList:[],//注意事项集合
        allCompanyList:[],//业主信息
        selectModel:{
          visable:false,
          loading:false
        },
        mattersNeedingAttention:[],
        mansionList:[],//选中楼宇的值
        mansionIds:[],//选择的ids
        mansionOptions:[],//项目选择器
        agencyAgreementVO:{},
        dueTimeList:[],//提醒时间设置
        startDate:null,//代理协议开始时间
        endDate:null,//代理协议结束时间
        mansionType: 1,// 选择的项目类型 1写字楼 2产业园
      }
    },
    beforeCreate () {
      this.agencyAgreementForm = this.$form.createForm(this)
    },
    mounted(){
      this.init()
    },
    methods:{
      openAddProprietorModal(){
        this.proprietorModalVisible = true;
      },
      cancelAddProprietorModal(){
        this.proprietorModalVisible = false;
      },
      saveProprietor(){
        this.$refs.addProprietorRef.submit();
      },
      saveProprietorSuccess(id,name,owner){
        let newObj = {
          id:id,
          companyName:name,
          companySortNameCn: owner.companySortNameCn,
        }
        this.allCompanyList = [];
        this.allCompanyList.push(newObj);
        this.agencyAgreementForm.setFieldsValue({
          ownerId: id
        });
        this.proprietorModalVisible = false;
        this.ownerSelect(id);
      },
      ownerSelect(ownerId){
        console.log("owner id ",ownerId)
        this.agencyAgreementForm.setFieldsValue({
          mansionIds: []
        })
        ownerMansionApi.selectMansionProjectByOwnerId(ownerId).then(res=>{
          if(res.code == 1){
            this.mansionList = res.data
            let mansionIds = [];
            this.mansionList.forEach(item=>{
              mansionIds.push(item.id);
            })
            this.agencyAgreementForm.setFieldsValue({
              mansionIds: mansionIds
            })
          }
        })
      },
      openSelectMansion(){
        this.selectModel.visable = true;
      },
      mansionChange(value){
        for(var i = 0;i < this.mansionList.length;i++){
          let indexOf = value.indexOf(this.mansionList[i].id);
          if(indexOf == -1){
            this.mansionList.splice(i,1);
            i--;
          }
        }
        this.fillMansionOptions();
      },
      fillMansionOptions(){
        this.mansionOptions = [];
        this.mansionList.forEach(data=>{
          let mansionOption = {
            label:data.name,
            value:data.id
          }
          this.mansionOptions.push(mansionOption);
        })
      },
      submitEvent(){
        this.$refs.selectMansion.confirmSelect();
      },
      cancelEvent(){
        this.selectModel.visable = false;
      },
      confirmSelect(mansionList, mansionType){
        this.mansionType = mansionType
        this.mansionList = mansionList;
        this.mansionIds = [];
        this.mansionList.forEach(item=>{
          this.mansionIds.push(item.id);
        })
      //  this.fillMansionOptions();
        this.cancelEvent();
        let _this = this;
        setTimeout(()=>{
          _this.agencyAgreementForm.setFieldsValue({
            mansionIds: _this.mansionIds
          })
        },0)
      },

      initAllCompanyList(companyName){
        if(companyName == '' || companyName == null){
          this.allCompanyList = []
          return
        }
        let p = new Promise((resolve, reject)=>{
          linkmanChangeRecordsApi.queryByName(companyName,3).then(res=>{
            if(res.code == 1){
              this.allCompanyList = res.data != null ? res.data : []
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      init(){
        this.queryCustomerConfirmationList();
        this.queryCommissionStandardList();
        this.queryDueTimeList();
        this.queryMattersNeedingAttentionList();
        if(this.agencyAgreementId){
          this.queryDetail();
        }
      },
      queryDetail(){
        let this_ = this
        agencyAgreementApi.selectOne(this_.agencyAgreementId).then(res=>{
          if(res.code == 1){
            this_.agencyAgreementVO = res.data
            this.mattersNeedingAttention = res.data.mattersNeedingAttention;
            this_.fillForm();
          }
        })
      },
      fillForm(){
        if(this.agencyAgreementVO.customerConfirmationCriteria != '~' && this.agencyAgreementVO.customerConfirmationCriteria){
          this.agencyAgreementVO.customerConfirmationCriteria = JSON.parse(this.agencyAgreementVO.customerConfirmationCriteria);
        }else{
          this.agencyAgreementVO.customerConfirmationCriteria = [];
        }
        if(this.agencyAgreementVO.commissionStandard != '~' && this.agencyAgreementVO.commissionStandard){
          this.agencyAgreementVO.commissionStandard = JSON.parse(this.agencyAgreementVO.commissionStandard)
        }else{
          this.agencyAgreementVO.commissionStandard = [];
        }
        if(this.agencyAgreementVO.mattersNeedingAttention != '~' && this.agencyAgreementVO.mattersNeedingAttention){
          this.agencyAgreementVO.mattersNeedingAttention = JSON.parse(this.agencyAgreementVO.mattersNeedingAttention)
        }else{
          this.agencyAgreementVO.mattersNeedingAttention = [];
        }
        if(this.agencyAgreementVO.dueTime == '~'){
          this.agencyAgreementVO.dueTime = undefined
        }
        if(this.agencyAgreementVO.returnCommissionAgreementRemarks == '~'){
          this.agencyAgreementVO.returnCommissionAgreementRemarks = undefined
        }
        if(this.agencyAgreementVO.mattersNeedingAttentionRemarks == '~'){
          this.agencyAgreementVO.mattersNeedingAttentionRemarks = undefined
        }
        if(this.agencyAgreementVO.commissionStandardRemarks == '~'){
          this.agencyAgreementVO.commissionStandardRemarks = undefined
        }
        if(this.agencyAgreementVO.customerConfirmationCriteriaRemarks == '~'){
          this.agencyAgreementVO.customerConfirmationCriteriaRemarks = undefined
        }
        if(this.agencyAgreementVO.mansionType != '~' && this.agencyAgreementVO.mansionType){
          this.mansionType = this.agencyAgreementVO.mansionType
        }
        if(this.agencyAgreementVO.agencyAgreementFileVOList){
          this.fileList = [];
          this.agencyAgreementVO.agencyAgreementFileVOList.forEach(item=>{
            let fileDO = {
              fileName:item.fileName,
              fileId:item.fileId
            }
            this.fileList.push(fileDO);
          })
        }
        if(this.agencyAgreementVO.agencyAgreementMansionVOList){
          var mansionIds = [];
          this.agencyAgreementVO.agencyAgreementMansionVOList.forEach(mansion=>{
            var mansion = {
              fileId:mansion.mansionImg,
              id:mansion.mansionId,
              name:mansion.mansionName
            }
            mansionIds.push(mansion.id);
            this.mansionList.push(mansion);
          })
          this.agencyAgreementVO["mansionIds"] = mansionIds;
        }
        this.allCompanyList = [];
        var company = {
          companyName:this.agencyAgreementVO.ownerName,
          companySortNameCn:this.agencyAgreementVO.ownerName,
          id:this.agencyAgreementVO.ownerId
        }
        this.allCompanyList.push(company);
        if(this.agencyAgreementVO.startDate != '~' && this.agencyAgreementVO.startDate ){
          var agencyDate = [];
          agencyDate.push(moment(this.agencyAgreementVO.startDate,'YYYY-MM-DD'))
          agencyDate.push(moment(this.agencyAgreementVO.endDate,'YYYY-MM-DD'))
          this.startDate = new Date(moment(this.agencyAgreementVO.startDate,'YYYY-MM-DD').format('YYYY-MM-DD'));
          this.endDate = new Date(moment(this.agencyAgreementVO.endDate,'YYYY-MM-DD').format('YYYY-MM-DD'));
          this.agencyAgreementVO["agencyDate"] = agencyDate;
        }
        setTimeout(()=>{
          this.agencyAgreementForm.setFieldsValue(this.agencyAgreementVO);
        },0)
      },
      queryCustomerConfirmationList(){
        let this_ = this
        getDatadictChildsByPath("system.business_key.agency_agreement_set.customer_confirm_set").then(res=>{
          if(res.data){
            this_.customerConfirmationList = [];
            res.data.forEach(item=>{
              var option = {
                label: item.wordValue,
                value: item.wordKey
              }
              this_.customerConfirmationList.push(option);
            })
          }
        })
      },
      queryCommissionStandardList(){
        let this_ = this
        getDatadictChildsByPath("system.business_key.agency_agreement_set.commission_standard_set").then(res=>{
          if(res.data){
            this_.commissionStandardList = [];
            res.data.forEach(item=>{
              var option = {
                label: item.wordValue,
                value: item.wordKey
              }
              this_.commissionStandardList.push(option);
            })
          }
        })
      },
      queryDueTimeList(){
        let this_ = this
        getDatadictChildsByPath("system.business_key.agency_agreement_set.due_time_set").then(res=>{
          if(res.data){
            this_.dueTimeList = res.data;
          }
        })
      },
      queryMattersNeedingAttentionList(){
        let this_ = this
        getDatadictChildsByPath("system.business_key.agency_agreement_set.matters_needing_attention_set").then(res=>{
          if(res.data){
            this_.mattersNeedingAttentionList = [];
            res.data.forEach(item=>{
              var option = {
                label: item.wordValue,
                value: item.wordKey
              }
              this_.mattersNeedingAttentionList.push(option);
            })
          }
        })
      },
      submit(){
        this.agencyAgreementForm.validateFieldsAndScroll({force:true},(err, values) => {
          if (!err) {
            if(this.fileList.length == 0){
              this.$message.error(this.$t('agencyAgreement.modal.filesErrorTip'));
              this.$emit("error");
              return
            }else{
              this.fillData(values);
            }
          }else{
            this.$message.warn("请正确填写表单")
            this.$emit("error");
          }
        });
      },
      dateChange(date,dateStr){
        if(date != null && date.length > 0){
          this.startDate = new Date(date[0].format('YYYY-MM-DD'));
          this.endDate = new Date(date[1].format('YYYY-MM-DD'));
        }else{
          this.startDate = null;
          this.endDate = null;
        }
      },
      fillData(data){
        if(this.agencyAgreementId){
          data["id"] = this.agencyAgreementId;
          data["signatureId"] = this.agencyAgreementVO.signatureId;
          data["version"] = this.agencyAgreementVO.version;
        }
        if(data.agencyDate){
          data["startDate"] = this.startDate;
          data["endDate"] = this.endDate;
        }
        if(data.mansionIds){
          let agencyAgreementMansionVOList = [];
          data.mansionIds.forEach(id=>{
            let agencyAgreementMansionVO = {
              mansionId:id
            }
            agencyAgreementMansionVOList.push(agencyAgreementMansionVO);
          })
          data["agencyAgreementMansionVOList"] = agencyAgreementMansionVOList;
          // 项目类型
          data["mansionType"] = this.mansionType;
        }
        if(this.fileList){
          let agencyAgreementFileVOList = [];
          this.fileList.forEach(file=>{
            let agencyAgreementFileVO = {
              fileId:file.fileId
            }
            agencyAgreementFileVOList.push(agencyAgreementFileVO);
          })
          data["agencyAgreementFileVOList"] = agencyAgreementFileVOList;
        }
        if(this.mansionList){
          var mansionNameStr = '';
          this.mansionList.forEach((mansion,index)=>{
            if(index == 0){
              mansionNameStr = mansionNameStr + mansion.name;
            }else{
              mansionNameStr = mansionNameStr + "," + mansion.name;
            }
          })
          data["mansionNameStr"] = mansionNameStr;
        }
        this.allCompanyList.forEach(company=>{
          if(data.ownerId == company.id){
            data["ownerName"] = company.companySortNameCn;
          }
        })
        if(this.agencyAgreementId){
          this.update(data);
        }else{
          this.save(data);
        }
      },
      update(data){
        agencyAgreementApi.update(data).then(res => {
          if (res.code == 1) {
            this.$message.success(this.$t('agencyAgreement.modal.updateSuccessTip'));
            this.$emit("saveSuccess");
          }
        }).finally(()=>{
          this.$emit("error");
        })
      },
      save(data){
        agencyAgreementApi.insert(data).then(res => {
          if (res.code == 1) {
            this.$message.success(this.$t('agencyAgreement.modal.saveSuccessTip'));
            this.$emit("saveSuccess");
          }
        }).finally(()=>{
          this.$emit("error");
        })
      },
      onChange(checkedValues){
        console.log('checked = ', checkedValues);
        console.log('value = ', this.value);
        this.mattersNeedingAttention = checkedValues;
        if(checkedValues.indexOf("return_commission_agreement") == -1){
          this.agencyAgreementForm.setFieldsValue({
            returnCommissionAgreementRemarks: ''
          })
        }
      },
      onChangeRemarks(e){
        console.log(`checked = ${e.target.checked}`);
      },
      delFile(index){
        this.fileList.splice(index,1);
      },
      onSuccess(file,fileId){
        this.fileList.push({fileName:file.name,fileId:fileId})
      },
    }
  }
</script>

<style scoped lang="less">
  .addBottomBtn{
    background: #3B2E26;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 30px;
    .addIcon{
      color: #ffffff;
      font-size: 12px;
    }
    .addBtnText{
      font-size: 12px;
      color: #ffffff;
      margin-left:4px;
    }
  }
  #addAgencyAgreement{
    .disabledClass{
      border: 1px solid #d9d9d9 !important;
    }
    .startStyle{
      display: inline-block;
      margin-left: 4px;
      content: '*';
      font-family: SimSun;
      line-height: 1;
      font-size: 14px;
      color: #f5222d;
    }
    .addProjectBtn{
      position: absolute;
      right: 0px;
      top:30px;
      width: 20px;
      height: 16px;
      border: 1px solid #FABE00;
      border-radius: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      .addIcon{
        font-size: 12px;
        color: #FABE00;
      }
    }
    .greyDiv{
      padding: 20px 20px 0 20px;
      background: rgba(248,249,251,0.62);
      border-radius: 0 0 4px 4px;
    }
    .titleRow{
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 20px;
      margin-bottom: 5px;
      .circle{
        margin-left: 12px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: #FABE00;
      }
      .titleText{
        padding: 0 10px;
        color: #333333;
        font-size: 14px;
      }
    }
    .fileRow{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: 30px;
      margin-bottom: 10px;
      .fileRowLeft{
        display: flex;
        flex-direction: row;
        align-items: center;
        .circle{
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background: #FABE00;
        }
        .fileTitle{
          font-size: 14px;
          color: #333333;
          margin-left: 10px;
        }
        .fileTip{
          font-size: 12px;
          color: #999999;
          margin-top: 4px;
          margin-left: 4px;
        }
      }
    }
    .fileDiv{
      padding: 20px;
      background: rgba(248,249,251,0.62);
      border-radius: 0 0 4px 4px;
    }
    .fileItem{
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 10px 0;
      border-bottom: 1px solid #E7E7E7;
      .fileIcon{
        font-size: 20px;
      }
      .fileName{
        flex:1;
        font-size: 12px;
        color: #333333;
        margin: 0 20px;
      }
      .delIcon{
        font-size: 20px;
        cursor: pointer;
      }
    }
    .fileItem:last-child{
      border-bottom: 0px;
    }
    .noFileClass{
      padding: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #999999;
    }

    .ant-select-dropdown-content{
      /deep/.invisible-item{
        display:initial !important;
      }
    }
    /deep/.invisible-item{
      display:none;
    }
  }
</style>